<div data-layout="public" class="public-layout flex min-h-screen flex-col bg-background font-body text-on-surface">
  <app-site-header [variant]="headerVariant" />
  <main class="flex flex-1 flex-col min-h-0">
    <router-outlet />
  </main>
  <app-site-footer />
  @if (session.isLearner()) {
    <app-learner-share-overlay />
  }
  <app-toast-container />
</div>
